export default "__VITE_ASSET__59ba46e1__"